import type { AbstractLeadFormState } from "@component/assets/AbstractLeadForm/AbstractLeadForm";
import { AbstractLeadForm } from "@component/assets/AbstractLeadForm/AbstractLeadForm";
import type { AbstractLeadFormFields, ProductType } from "@component/assets/AbstractLeadForm/types";
import type { EventComponentType } from "@utils/google-analytics-4.type";
import type { ReactNode } from "react";
import React from "react";
import * as Step from "./Steps";
import type { NhpSmallLeadCalculatorRequest, NhpSmallLeadCalculatorResponse } from "./types";

export type NhpFormFields = AbstractLeadFormFields;

/**
 * @Shortcode
 *
 * @title "NHP Hajrá kalkulátor"
 * @shortcode "nhp_small"
 * @slug "nhp"
 * @type "calculator"
 */
export class NhpSmallCalculator extends AbstractLeadForm<
	NhpSmallLeadCalculatorRequest,
	NhpSmallLeadCalculatorResponse
> {
	// EventParams
	protected readonly productTypes: string = "FGS";
	protected readonly componentType: EventComponentType = "small-calculator";

	public static defaultProps = {
		title: "Add meg további adataidat és részletesen tájékoztatunk!",
		outsideTitle: "NHP HAJRÁ Kalkulátor",
		outsideTitleLink: "/vallalati/hitel/novekedesi-hitel/",
		bottomLogo: true,
	};

	protected getInitialState(): AbstractLeadFormState<AbstractLeadFormFields> {
		return {
			...super.getInitialState(),
			activeStep: "start",
		};
	}

	protected renderSteps(): ReactNode {
		return <Step.Start stepName="start" defaultTarget="step-1" />;
	}

	protected getAutoresponderName(): string {
		return undefined;
	}

	protected getAutoresponderFields(): Record<string, any> {
		return {};
	}

	protected getProductType(): ProductType {
		return "FGS";
	}

	protected getComponentName(): string {
		return "NhpSmallCalculator";
	}
}

export default NhpSmallCalculator;
